export default [
  {
    path: 'product/quote',
    component: () => import('@/views/product/ProductQuote'),
    meta: { title: '报价' }
  },
  {
    path: 'product/quote/:frmNo/:vehicleId/:vehicleOwnerId',
    component: () => import('@/views/product/ProductQuote'),
    props: route => ({
      type: 'quote',
      ...route.params
    }),
    meta: { title: '报价' }
  },
  {
    path: 'product/new',
    component: () => import('@/views/product/ProductPre'),
    props: {
      type: 'new'
    },
    meta: { title: '新保', componentName: 'ProductPre' }
  },
  {
    path: 'product/aftersale',
    component: () => import('@/views/product/ProductPre'),
    props: {
      type: 'aftersale'
    },
    meta: { title: '售后续保', componentName: 'ProductPre' }
  },
  {
    path: '/product/continue/create/new',
    component: () => import('@/views/product/ProductPre'),
    props: {
      type: 'continue_create'
    },
    meta: { title: '续保新建', componentName: 'ProductPre' }
  },
  {
    path: '/product/continue/follow/:vehicleId/:vehicleOwnerId',
    component: () => import('@/views/product/ProductPre'),
    props: route => ({
      type: 'continue',
      vehicleId: route.params.vehicleId,
      vehicleOwnerId: route.params.vehicleOwnerId
    }),
    meta: { title: '续保录入', componentName: 'ProductPre' }
  },
  {
    path: '/query/list/:vehicleId',
    component: () => import('@/views/product/QueryList'),
    props: true,
    meta: { title: '询价单查询' },
    children: [
      {
        path: 'detail/:vehicleEnquiryId',
        props: true,
        component: () => import('@/views/product/QueryDetail'),
        meta: { title: '询价单详情' }
      }
    ]
  },
  {
    path: '/query/detail/:vehicleEnquiryId',
    props: true,
    component: () => import('@/views/product/QueryDetail'),
    meta: { title: '询价单详情' }
  },
  {
    path: 'product/continue/list',
    component: () => import('@/views/product/ContinueList'),
    meta: { title: '全部续保客户', componentName: 'ContinueList' },
  },
  {
    path: 'product/continue/list/workbench',
    component: () => import('@/views/product/ContinueList'),
    props: {
      type: 'workbench'
    },
    meta: { title: '待办', componentName: 'ContinueList' },
  },
  {
    path: 'revisit/track',
    component: () => import('@/views/product/RevisitTrack.vue'),
    meta: { title: '回访跟踪', componentName: 'RevisitTrack' },
  },
  {
    path: 'product/elec',
    component: () => import('@/views/product/ProductPre'),
    props: () => ({
      type: 'continue_create',
      elecInfo: {
        vehicleId: '',
        customerId: ''
      }
    }),
    meta: { title: '电销投保', componentName: 'ProductPre' }
  },
  {
    path: 'product/insure/:q',
    component: () => import('@/views/product/ProductInsure'),
    props: true,
    meta: { title: '投保', componentName: 'ProductInsure' }
  },
  {
    path: 'renewal/setting',
    component: () => import('@/views/product/RenewalSetting'),
    meta: { title: '续保分配', componentName: 'RenewalSetting' }
  }
]
